import { render, staticRenderFns } from "./SHeader.vue?vue&type=template&id=889c9a52&scoped=true"
import script from "./SHeader.vue?vue&type=script&lang=js"
export * from "./SHeader.vue?vue&type=script&lang=js"
import style0 from "./SHeader.vue?vue&type=style&index=0&id=889c9a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889c9a52",
  null
  
)

export default component.exports